// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** IAAnywhere Branded Styling **/

:root {
    /* Fonts */

    --opensans-font: 'Open Sans', sans-serif;
    --opensans-light: 300;
    --opensans-regular: 400;
    --opensans-semibold: 600;

    --roboto-font: 'Roboto', sans-serif;
    --roboto-light: 300;
    --roboto-regular: 400;
    --roboto-medium: 500;
    --roboto-semibold: 600;

    --font-size: 16px;
    --line-height: 1.5;
    --font-weight: --opensans-light;

    /* Branded Colors */

    --white: #ffffff;
    --white-002: #fbfbfb;
    --white-003: #f7f8fa;

    --body-background: #ebecee;
    --border-grey: #ddd;
    --grey-001: #3f4554;
    --grey-002: #323439;
    --grey-003: #495061;
    --grey-004: #9a9faa;
    --grey-005: #808695;
    --grey-006: #b0b4bd;
    --grey-007: #a9a9a9;

    --aqua-001: #04c3ca;
    --aqua-002: #1cd5db;
    --aqua-003: #dde3ec;
    --aqua-004: #8290a3;
    --aqua-005: #ebfafb;

    --red-001: #d91e18;
    --red-002: #a35151;

    --green-001: #51a351;

    --black-001: #495057;
    --black-002: #212529;
}

/* Viewport Size Breakpoints */

/** --g-3xs: 320px;  double extra small devices (<=320px) **/

/** --g-2xs: 446px;  double extra small devices (<=445px) **/

/** --g-sm: 576px;  small devices (landscape phones, >=576 & <=766) **/

/** --g-md: 767px;  medium devices (tablets, >=767 & <=991) **/

/** --g-lg: 992px;  large devices (desktops, >=992 & <=1199) **/

/** --g-xl: 1200px;  extra large devices (large desktops, >=1200) **/

@custom-media --3xs-viewport (max-width: 320px);

@custom-media --3xs-min-viewport (min-width: 320px);

@custom-media --2xs-viewport (max-width: 446px);

@custom-media --2xs-min-viewport (min-width: 446px);

html,
body {
  min-height: 100%;
}

.humane,
.humane-jackedup {
  position: fixed;
  transition: all 0.6s ease-in-out;
  z-index: 100000;
  filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=100);
}

.humane,
.humane-jackedup {
  font-size: 1rem;
  font-family: 'Open Sans', sans-serif;
  font-weight: 400;
  top: 20px;
  left: 30%;
  opacity: 0;
  width: 40%;
  padding: 10px;
  text-align: center;
  color: #323439;
  background-color: #fff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
  transform: translateY(-100px);
}

.humane p,
.humane-jackedup p,
.humane ul,
.humane-jackedup ul {
  margin: 0;
  padding: 0;
}

.humane ul,
.humane-jackedup ul {
  list-style: none;
}

.humane.humane-jackedup-info,
.humane-jackedup.humane-jackedup-info {
  background-color: #04c3ca;
  color: #fff;
}

.humane.humane-jackedup-success,
.humane-jackedup.humane-jackedup-success {
  background-color: #51a351;
  color: #fff;
}

.humane.humane-jackedup-error,
.humane-jackedup.humane-jackedup-error {
  background-color: #d91e18;
  color: #fff;
}

.humane-animate,
.humane-jackedup.humane-jackedup-animate {
  opacity: 1;
  transform: translateY(0);
}

.humane-animate:hover,
.humane-jackedup.humane-jackedup-animate:hover {
  opacity: 0.7;
}

.humane-js-animate,
.humane-jackedup.humane-jackedup-js-animate {
  opacity: 1;
  transform: translateY(0);
}

.humane-js-animate:hover,
.humane-jackedup.humane-jackedup-js-animate:hover {
  opacity: 0.7;
  filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=70);
}

@media screen and (max-width: 992px) {
  .humane,
  .humane-jackedup {
    top: 20px;
    left: 20%;
    width: 60%;
  }
}

@media screen and (max-width: 576px) {
  .humane,
  .humane-jackedup {
    top: 0;
    left: 0;
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/branding.css","webpack://./src/shared/jackedup.css"],"names":[],"mappings":"AAAA,iCAAiC;;AAEjC;IACI,UAAU;;IAEV,wCAAwC;IACxC,qBAAqB;IACrB,uBAAuB;IACvB,wBAAwB;;IAExB,mCAAmC;IACnC,mBAAmB;IACnB,qBAAqB;IACrB,oBAAoB;IACpB,sBAAsB;;IAEtB,iBAAiB;IACjB,kBAAkB;IAClB,+BAA+B;;IAE/B,mBAAmB;;IAEnB,gBAAgB;IAChB,oBAAoB;IACpB,oBAAoB;;IAEpB,0BAA0B;IAC1B,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;;IAEnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;;IAEnB,kBAAkB;IAClB,kBAAkB;;IAElB,oBAAoB;;IAEpB,oBAAoB;IACpB,oBAAoB;AACxB;;AAGA,8BAA8B;;AAE9B,4DAA4D;;AAC5D,4DAA4D;;AAC5D,sEAAsE;;AACtE,8DAA8D;;AAC9D,+DAA+D;;AAC/D,oEAAoE;;AAUpE,+CAA+C;;AAC/C,mDAAmD;;AACnD,+CAA+C;;AAC/C,mDAAmD;;ACtEnD;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;EAKf,gCAAgC;EAChC,eAAe;EACf,4DAA4D;AAC9D;;AAEA;;EAEE,eAAe;EACf,oCAAiC;EACjC,gBAAoC;EACpC,SAAS;EACT,SAAS;EACT,UAAU;EACV,UAAU;EACV,aAAa;EACb,kBAAkB;EAClB,cAAsB;EACtB,sBAAsB;EAEtB,wCAAwC;EAKxC,6BAA6B;AAC/B;;AAEA;;;;EAIE,SAAS;EACT,UAAU;AACZ;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,yBAAiC;EACjC,WAAW;AACb;;AAEA;;EAEE,yBAAkC;EAClC,WAAW;AACb;;AAEA;;EAEE,yBAAgC;EAChC,WAAW;AACb;;AAEA;;EAEE,UAAU;EAKV,wBAAwB;AAC1B;;AAEA;;EAEE,YAAY;AACd;;AAEA;;EAEE,UAAU;EAKV,wBAAwB;AAC1B;;AAEA;;EAEE,YAAY;EACZ,2DAA2D;AAC7D;;AAEA;EACE;;IAEE,SAAS;IACT,SAAS;IACT,UAAU;EACZ;AACF;;AAEA;EACE;;IAEE,MAAM;IACN,OAAO;IACP,WAAW;EACb;AACF","sourcesContent":["/** IAAnywhere Branded Styling **/\r\n\r\n:root {\r\n    /* Fonts */\r\n\r\n    --opensans-font: 'Open Sans', sans-serif;\r\n    --opensans-light: 300;\r\n    --opensans-regular: 400;\r\n    --opensans-semibold: 600;\r\n\r\n    --roboto-font: 'Roboto', sans-serif;\r\n    --roboto-light: 300;\r\n    --roboto-regular: 400;\r\n    --roboto-medium: 500;\r\n    --roboto-semibold: 600;\r\n\r\n    --font-size: 16px;\r\n    --line-height: 1.5;\r\n    --font-weight: --opensans-light;\r\n\r\n    /* Branded Colors */\r\n\r\n    --white: #ffffff;\r\n    --white-002: #fbfbfb;\r\n    --white-003: #f7f8fa;\r\n\r\n    --body-background: #ebecee;\r\n    --border-grey: #ddd;\r\n    --grey-001: #3f4554;\r\n    --grey-002: #323439;\r\n    --grey-003: #495061;\r\n    --grey-004: #9a9faa;\r\n    --grey-005: #808695;\r\n    --grey-006: #b0b4bd;\r\n    --grey-007: #a9a9a9;\r\n\r\n    --aqua-001: #04c3ca;\r\n    --aqua-002: #1cd5db;\r\n    --aqua-003: #dde3ec;\r\n    --aqua-004: #8290a3;\r\n    --aqua-005: #ebfafb;\r\n\r\n    --red-001: #d91e18;\r\n    --red-002: #a35151;\r\n\r\n    --green-001: #51a351;\r\n\r\n    --black-001: #495057;\r\n    --black-002: #212529;\r\n}\r\n\r\n\r\n/* Viewport Size Breakpoints */\r\n\r\n/** --g-3xs: 320px;  double extra small devices (<=320px) **/\r\n/** --g-2xs: 446px;  double extra small devices (<=445px) **/\r\n/** --g-sm: 576px;  small devices (landscape phones, >=576 & <=766) **/\r\n/** --g-md: 767px;  medium devices (tablets, >=767 & <=991) **/\r\n/** --g-lg: 992px;  large devices (desktops, >=992 & <=1199) **/\r\n/** --g-xl: 1200px;  extra large devices (large desktops, >=1200) **/\r\n\r\n@custom-media --xl-viewport (max-width: 1200px);\r\n@custom-media --xl-min-viewport (min-width: 1200px);\r\n@custom-media --lg-viewport (max-width: 992px);\r\n@custom-media --lg-min-viewport (min-width: 992px);\r\n@custom-media --md-viewport (max-width: 767px);\r\n@custom-media --md-min-viewport (min-width: 767px);\r\n@custom-media --sm-viewport (max-width: 576px);\r\n@custom-media --sm-min-viewport (min-width: 576px);\r\n@custom-media --3xs-viewport (max-width: 320px);\r\n@custom-media --3xs-min-viewport (min-width: 320px);\r\n@custom-media --2xs-viewport (max-width: 446px);\r\n@custom-media --2xs-min-viewport (min-width: 446px);","@import '../branding.css';\r\n\r\nhtml,\r\nbody {\r\n  min-height: 100%;\r\n}\r\n\r\n.humane,\r\n.humane-jackedup {\r\n  position: fixed;\r\n  -moz-transition: all 0.6s ease-in-out;\r\n  -webkit-transition: all 0.6s ease-in-out;\r\n  -ms-transition: all 0.6s ease-in-out;\r\n  -o-transition: all 0.6s ease-in-out;\r\n  transition: all 0.6s ease-in-out;\r\n  z-index: 100000;\r\n  filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=100);\r\n}\r\n\r\n.humane,\r\n.humane-jackedup {\r\n  font-size: 1rem;\r\n  font-family: var(--opensans-font);\r\n  font-weight: var(--opensans-regular);\r\n  top: 20px;\r\n  left: 30%;\r\n  opacity: 0;\r\n  width: 40%;\r\n  padding: 10px;\r\n  text-align: center;\r\n  color: var(--grey-002);\r\n  background-color: #fff;\r\n  -webkit-box-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);\r\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);\r\n  -moz-transform: translateY(-100px);\r\n  -webkit-transform: translateY(-100px);\r\n  -ms-transform: translateY(-100px);\r\n  -o-transform: translateY(-100px);\r\n  transform: translateY(-100px);\r\n}\r\n\r\n.humane p,\r\n.humane-jackedup p,\r\n.humane ul,\r\n.humane-jackedup ul {\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\n.humane ul,\r\n.humane-jackedup ul {\r\n  list-style: none;\r\n}\r\n\r\n.humane.humane-jackedup-info,\r\n.humane-jackedup.humane-jackedup-info {\r\n  background-color: var(--aqua-001);\r\n  color: #fff;\r\n}\r\n\r\n.humane.humane-jackedup-success,\r\n.humane-jackedup.humane-jackedup-success {\r\n  background-color: var(--green-001);\r\n  color: #fff;\r\n}\r\n\r\n.humane.humane-jackedup-error,\r\n.humane-jackedup.humane-jackedup-error {\r\n  background-color: var(--red-001);\r\n  color: #fff;\r\n}\r\n\r\n.humane-animate,\r\n.humane-jackedup.humane-jackedup-animate {\r\n  opacity: 1;\r\n  -moz-transform: translateY(0);\r\n  -webkit-transform: translateY(0);\r\n  -ms-transform: translateY(0);\r\n  -o-transform: translateY(0);\r\n  transform: translateY(0);\r\n}\r\n\r\n.humane-animate:hover,\r\n.humane-jackedup.humane-jackedup-animate:hover {\r\n  opacity: 0.7;\r\n}\r\n\r\n.humane-js-animate,\r\n.humane-jackedup.humane-jackedup-js-animate {\r\n  opacity: 1;\r\n  -moz-transform: translateY(0);\r\n  -webkit-transform: translateY(0);\r\n  -ms-transform: translateY(0);\r\n  -o-transform: translateY(0);\r\n  transform: translateY(0);\r\n}\r\n\r\n.humane-js-animate:hover,\r\n.humane-jackedup.humane-jackedup-js-animate:hover {\r\n  opacity: 0.7;\r\n  filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=70);\r\n}\r\n\r\n@media screen and (--lg-viewport) {\r\n  .humane,\r\n  .humane-jackedup {\r\n    top: 20px;\r\n    left: 20%;\r\n    width: 60%;\r\n  }\r\n}\r\n\r\n@media screen and (--sm-viewport) {\r\n  .humane,\r\n  .humane-jackedup {\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
